import { useState, useEffect } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2';

const TEST_NAME = 'addItemLocationPdp';

export const useAddItemLocationPdpVariant = (): boolean | null => {
    const [isAddItemLocationPdpVariant, setIsAddItemLocationPdpVariant] = useState<boolean | null>(
        null
    );

    useEffect(() => {
        const isVariant = getAbTestV2(TEST_NAME)?.variant === 'variant';
        setIsAddItemLocationPdpVariant(isVariant);
    }, []);

    return isAddItemLocationPdpVariant;
};

export const trackAddItemLocationPdpTest = (): void => {
    trackAbTestV2Variant(TEST_NAME);
};
